// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3fq7v","buttons":"PendingPaymentAlert_buttons__M0PAH"};